module.exports = __webpack_public_path__ + "img/user.f1305a83.png";